import { call, put, takeLatest } from "redux-saga/effects";
import cube from "services/cube";
import moment from "moment";
import sweetAlert from "sweetalert";
import FileDownload from "js-file-download";

import {
  Creators as ReportsActions,
  Types as ReportsTypes,
} from "store/ducks/reports";

function filterReportProvisionPoints(filters) {
  return {
    date_start:
      filters.start_at !== null
        ? moment(filters.start_at).format("YYYY-MM-DD")
        : null,
    date_end:
      filters.end_at !== null
        ? moment(filters.end_at).format("YYYY-MM-DD")
        : null,
  };
}

function* getReportPointsProvisionRequest(action) {
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportProvisionPoints, filters);
    const url = `/reports/provision/points`;
    const response = yield call(cube.get, url, { params });

    yield put(ReportsActions.getReportPointsProvisionSuccess(response));
  } catch (error) {
    yield put(ReportsActions.getReportPointsProvisionFailure());
  }
}

function* exportReportProvisionPointsRequest(action) {
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportProvisionPoints, filters);
    const url = `/reports/provision/points/analytics`;
    const response = yield call(cube.get, url, {
      responseType: "blob",
      params,
    });

    FileDownload(response.data, "relatorio-provisao-pontos.xls");

    yield put(ReportsActions.exportReportProvisionPointsSuccess(response.data));
  } catch (error) {
    yield call(
      sweetAlert,
      "Falha ao Exportar",
      "Não foi possível exportar a planilha",
      "error"
    );
    yield put(ReportsActions.exportReportProvisionPointsFailure());
  }
}

function filterReportVoucherExpenses(filters) {
  return {
    date_start:
      filters.start_at !== null
        ? moment(filters.start_at).format("YYYY-MM-DD")
        : null,
    date_end:
      filters.end_at !== null
        ? moment(filters.end_at).format("YYYY-MM-DD")
        : null,
  };
}

function* getReportVouchersExpensesRequest(action) {
  try {
    const { filters } = action.payload;

    if (filters === null) {
      yield put(ReportsActions.getReportVouchersExpensesSuccess({ data: [] }));
      return;
    }

    const params = yield call(filterReportVoucherExpenses, filters);
    const url = `/reports/vouchers`;
    const response = yield call(cube.get, url, { params });

    yield put(ReportsActions.getReportVouchersExpensesSuccess(response.data));
  } catch (error) {
    yield put(ReportsActions.getReportVouchersExpensesfailure());
  }
}

function* exportReportVouchersExpensesRequest(action) {
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportVoucherExpenses, filters);
    const url = `/reports/vouchers/analytics`;
    const response = yield call(cube.get, url, {
      responseType: "blob",
      params,
    });

    FileDownload(response.data, "relatorio-despesas-vouchers.xls");

    yield put(
      ReportsActions.exportReportVouchersExpensesSuccess(response.data)
    );
  } catch (error) {
    yield call(
      sweetAlert,
      "Falha ao Exportar",
      "Não foi possível exportar a planilha",
      "error"
    );
    yield put(ReportsActions.exportReportVouchersExpensesFailure());
  }
}

function filterReportTickets(filters) {
  return {
    place_id: filters.place_id.value !== "" ? filters.place_id.value : null,
    date_start:
      filters.date_start !== null
        ? moment(filters.date_start).format("YYYY-MM-DD")
        : null,
    date_end:
      filters.date_end !== null
        ? moment(filters.date_end).format("YYYY-MM-DD")
        : null,
    plan_ids: filters.plans.map((plan) => plan.value) || [],
    channel_ids:
      !!filters.channels.length !== ""
        ? filters.channels.map((channel) => channel.value)
        : null,
  };
}

function* getReportTicketsRequest(action) {
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportTickets, filters);
    const url = `reports/average_tickets`;
    const response = yield call(cube.get, url, { params });

    yield put(ReportsActions.getReportTicketsSuccess(response.data));
  } catch (error) {
    yield put(ReportsActions.getReportTicketsFailure());
  }
}

function* exportReportTicketsRequest(action) {
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportTickets, filters);
    const url = `reports/average_tickets/analytics`;
    const response = yield call(cube.get, url, {
      responseType: "blob",
      params,
    });

    FileDownload(response.data, "relatorio-ticket-medio-faturamento.xls");

    yield put(ReportsActions.exportReportTicketsSuccess(response.data));
  } catch (error) {
    yield call(
      sweetAlert,
      "Falha ao Exportar",
      "Não foi possível exportar a planilha",
      "error"
    );
    yield put(ReportsActions.exportReportTicketsFailure());
  }
}

function filterReportBenefits(filters) {
  return {
    place_ids: filters.stores.map((place) => place.value),
    region_ids: filters.regions.map((region) => region.value),
    date_start:
      filters.date_start !== null
        ? moment(filters.date_start).format("YYYY-MM-DD")
        : null,
    date_end:
      filters.date_end !== null
        ? moment(filters.date_end).format("YYYY-MM-DD")
        : null,
    discount: filters.discount ? filters.discount.value : null,
    voucher_id: filters.voucher_id ? filters.voucher_id.value : null,
    campaign_id: filters.campaign ? filters.campaign.value : null,
    channels_ids: !!filters.channels.length
      ? filters.channels.map((channel) => channel.value).join(",")
      : null,
  };
}

function* getReportBenefitsRequest(action) {
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportBenefits, filters);
    const url = `reports/benefits`;

    const response = yield call(cube.get, url, { params });

    yield put(ReportsActions.getReportBenefitsSuccess(response.data));
  } catch (error) {
    yield put(ReportsActions.getReportBenefitsFailure());
  }
}

function* exportReportBenefitsRequest(action) {
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportBenefits, filters);
    const url = `reports/benefits/analytic`;
    const response = yield call(cube.get, url, {
      responseType: "blob",
      params,
    });
    FileDownload(
      response.data,
      `relatorio-de-beneficios-${moment().format("DD-MM-YYYY")}.xls`
    );

    yield put(ReportsActions.exportReportBenefitSuccess(response.data));
  } catch (error) {
    yield call(
      sweetAlert,
      "Falha ao Exportar",
      "Não foi possível exportar a planilha",
      "error"
    );
    yield put(ReportsActions.exportReportBenefitFailure());
  }
}

function filterReportPoints(filters) {

  return {
    place_ids: filters.place_ids.map((store) => store.value) || [],
    date_start:
      filters.date_start !== null
        ? moment(filters.date_start).format("YYYY-MM-DD")
        : null,
    date_end:
      filters.date_end !== null
        ? moment(filters.date_end).format("YYYY-MM-DD")
        : null,
    plan_ids: filters.plans.map((plan) => plan.value) || [],
  };
}

function* getReportPointsRequest(action) {
  
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportPoints, filters);
    const url = `reports/points`;
    const response = yield call(cube.get, url, { params });
    yield put(ReportsActions.getReportPointsSuccess(response.data));
  } catch (error) {
    yield put(ReportsActions.getReportPointsFailure());
  }
}

function* exportReportPointsRequest(action) {
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportPoints, filters);
    const url = `reports/points/analytics`;
    const response = yield call(cube.get, url, {
      responseType: "blob",
      params,
    });

    FileDownload(response.data, "relatorio-de-pontos.xls");

    yield put(ReportsActions.exportReportPointsSuccess(response.data));
  } catch (error) {
    yield call(
      sweetAlert,
      "Falha ao Exportar",
      "Não foi possível exportar a planilha",
      "error"
    );
    yield put(ReportsActions.exportReportPointsFailure());
  }
}

function filterReportRegisterRanking(filters) {
  return {
    place_ids:
      !!filters.stores.length !== ""
        ? filters.stores.map((store) => store.value)
        : null,
    date_start:
      filters.date_start !== null
        ? moment(filters.date_start).format("YYYY-MM-DD")
        : null,
    date_end:
      filters.date_end !== null
        ? moment(filters.date_end).format("YYYY-MM-DD")
        : null,
    plan_code:
      filters.plan && filters.plan.label !== "" ? filters.plan.value : null,
  };
}

function* getReportRegisterRankingRequest(action) {
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportRegisterRanking, filters);
    const url = `/reports/registrations`;
    const response = yield call(cube.get, url, { params });

    yield put(ReportsActions.getReportRegisterRankingSuccess(response.data));
  } catch (error) {
    yield put(ReportsActions.getReportRegisterRankingFailure());
  }
}

function* exportReportRegisterRankingRequest(action) {
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportRegisterRanking, filters);
    const url = `/reports/registrations/analytics`;

    const response = yield call(cube.get, url, {
      responseType: "blob",
      params,
    });

    FileDownload(
      response.data,
      `relatorio-de-ranking-cadastros-${moment().format("DD-MM-YYYY")}.xls`
    );

    yield put(ReportsActions.exportReportRegisterRankingSuccess(response.data));
  } catch (error) {
    yield call(
      sweetAlert,
      "Falha ao Exportar",
      "Não foi possível exportar a planilha",
      "error"
    );
    yield put(ReportsActions.exportReportRegisterRankingFailure());
  }
}

function filterReportPointsRanking(filters) {
  return {
    place_ids:
      !!filters.stores.length !== ""
        ? filters.stores.map((store) => store.value)
        : null,
    date_start:
      filters.date_start !== null
        ? moment(filters.date_start).format("YYYY-MM-DD")
        : null,
    date_end:
      filters.date_end !== null
        ? moment(filters.date_end).format("YYYY-MM-DD")
        : null,
  };
}

function* getReportPointsRankingRequest(action) {
  try {
    const { filters } = action.payload;
    const { type } = filters;
    const params = yield call(filterReportPointsRanking, filters);

    const url =
      type === "ticket"
        ? `reports/rankings/average_ticket?`
        : type === "vouchers"
        ? `reports/rankings/used_vouchers?`
        : `reports/rankings/points?`;

    const response = yield call(cube.get, url, { params });

    yield put(ReportsActions.getReportPointsRankingSuccess(response.data));
  } catch (error) {
    yield put(ReportsActions.getReportPointsRankingFailure());
  }
}

function* exportReportPointsRankingRequest(action) {
  try {
    const { filters } = action.payload;
    const { type } = filters;
    const params = yield call(filterReportPointsRanking, filters);

    const url =
      type === "ticket"
        ? `reports/rankings/average_ticket/analytics?`
        : type === "vouchers"
        ? `reports/rankings/used_vouchers/analytics?`
        : `reports/rankings/points/analytics?`;

    const response = yield call(cube.get, url, {
      responseType: "blob",
      params,
    });

    FileDownload(response.data, "relatorio-de-ranking-pontos.xls");

    yield put(ReportsActions.exportReportPointsRankingSuccess(response.data));
  } catch (error) {
    yield call(
      sweetAlert,
      "Falha ao Exportar",
      "Não foi possível exportar a planilha",
      "error"
    );
    yield put(ReportsActions.exportReportPointsRankingFailure());
  }
}

function filterReportGeneral(filters) {
  return {
    region_id: filters.region !== null ? filters.region.value : null,
    place_ids:
      !!filters.stores.length !== ""
        ? filters.stores.map((store) => store.value)
        : null,
    date_start:
      filters.date_start !== null
        ? moment(filters.date_start).format("YYYY-MM-DD")
        : null,
    date_end:
      filters.date_end !== null
        ? moment(filters.date_end).format("YYYY-MM-DD")
        : null,
  };
}

function* getReportGeneralRequest(action) {
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportGeneral, filters);
    const url = `reports/general`;
    const response = yield call(cube.get, url, { params });

    yield put(ReportsActions.getReportGeneralSuccess(response.data));
  } catch (error) {
    yield put(ReportsActions.getReportGeneralFailure());
  }
}

function* exportReportGeneralRequest(action) {
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportGeneral, filters);
    const url = `/reports/general/analytics`;
    const response = yield call(cube.get, url, {
      responseType: "blob",
      params,
    });
    FileDownload(
      response.data,
      `relatorio-geral-${moment().format("DD-MM-YYYY")}.xls`
    );

    yield put(ReportsActions.exportReportGeneralSuccess(response.data));
  } catch (error) {
    yield call(
      sweetAlert,
      "Falha ao Exportar",
      "Não foi possível exportar a planilha",
      "error"
    );
    yield put(ReportsActions.exportReportGeneralFailure());
  }
}

function filterReportWebpremios(filters, withDate = false) {
  return {
    order_id: filters.order_id !== "" ? filters.order_id : null,
    external_order_id:
      filters.external_order_id !== "" ? filters.external_order_id : null,
    date_start:
      withDate && filters.date_start !== null
        ? moment(filters.date_start).format("YYYY-MM-DD")
        : null,
    date_end:
      withDate && filters.date_end !== null
        ? moment(filters.date_end).format("YYYY-MM-DD")
        : null,
  };
}

function* getReportWebpremiosRequest(action) {
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportWebpremios, filters);
    const url = `reports/webpremios`;
    const response = yield call(cube.get, url, { params });

    yield put(ReportsActions.getReportWebpremiosSuccess(response.data));
  } catch (error) {
    yield put(ReportsActions.getReportWebpremiosFailure());
  }
}

function* exportReportWebpremiosRequest(action) {
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportWebpremios, filters, true);
    const url = `reports/webpremios/analytics`;
    const response = yield call(cube.get, url, {
      responseType: "blob",
      params,
    });
    FileDownload(
      response.data,
      `relatorio-contabil-webpremios-${moment().format("DD-MM-YYYY")}.xls`
    );

    yield put(ReportsActions.exportReportWebpremiosSuccess(response.data));
  } catch (error) {
    yield call(
      sweetAlert,
      "Falha ao Exportar",
      "Não foi possível exportar a planilha",
      "error"
    );

    yield put(ReportsActions.exportReportWebpremiosFailure());
  }
}

function filterReportAccountant(filters) {
  return {
    date_start:
      filters.date_start !== null
        ? moment(filters.date_start).format("YYYY-MM-DD")
        : null,
    date_end:
      filters.date_end !== null
        ? moment(filters.date_end).format("YYYY-MM-DD")
        : null,
  };
}

function* exportReportAccountantRequest(action) {
  try {
    const { filters } = action.payload;
    const params = yield call(filterReportAccountant, filters);
    const url = `/reports/vouchers/accounting/analytics`;
    const response = yield call(cube.get, url, {
      responseType: "blob",
      params,
    });
    FileDownload(
      response.data,
      `relatorio-contabil-${moment().format("DD-MM-YYYY")}.xls`
    );

    yield put(ReportsActions.exportReportAccountantSuccess(response.data));
  } catch (error) {
    yield call(
      sweetAlert,
      "Falha ao Exportar",
      "Não foi possível exportar a planilha",
      "error"
    );

    yield put(ReportsActions.exportReportAccountantFailure());
  }
}

export default function* sagaReports() {
  yield takeLatest(
    ReportsTypes.GET_POINTS_PROVISION_REQUEST,
    getReportPointsProvisionRequest
  );
  yield takeLatest(
    ReportsTypes.GET_VOUCHERS_EXPENSES_REQUEST,
    getReportVouchersExpensesRequest
  );
  yield takeLatest(
    ReportsTypes.EXPORT_VOUCHERS_EXPENSES_REQUEST,
    exportReportVouchersExpensesRequest
  );
  yield takeLatest(
    ReportsTypes.EXPORT_PROVISION_POINTS_REQUEST,
    exportReportProvisionPointsRequest
  );
  yield takeLatest(ReportsTypes.GET_TICKETS_REQUEST, getReportTicketsRequest);
  yield takeLatest(
    ReportsTypes.EXPORT_TICKETS_REQUEST,
    exportReportTicketsRequest
  );
  yield takeLatest(ReportsTypes.GET_BENEFITS_REQUEST, getReportBenefitsRequest);
  yield takeLatest(
    ReportsTypes.EXPORT_BENEFITS_REQUEST,
    exportReportBenefitsRequest
  );
  yield takeLatest(ReportsTypes.GET_POINTS_REQUEST, getReportPointsRequest);
  yield takeLatest(
    ReportsTypes.EXPORT_POINTS_REQUEST,
    exportReportPointsRequest
  );
  yield takeLatest(
    ReportsTypes.GET_REGISTER_RANKING_REQUEST,
    getReportRegisterRankingRequest
  );
  yield takeLatest(
    ReportsTypes.EXPORT_REGISTER_RANKING_REQUEST,
    exportReportRegisterRankingRequest
  );
  yield takeLatest(
    ReportsTypes.GET_POINTS_RANKING_REQUEST,
    getReportPointsRankingRequest
  );
  yield takeLatest(
    ReportsTypes.EXPORT_POINTS_RANKING_REQUEST,
    exportReportPointsRankingRequest
  );
  yield takeLatest(ReportsTypes.GET_GENERAL_REQUEST, getReportGeneralRequest);
  yield takeLatest(
    ReportsTypes.EXPORT_GENERAL_REQUEST,
    exportReportGeneralRequest
  );
  yield takeLatest(
    ReportsTypes.GET_WEBPREMIOS_REQUEST,
    getReportWebpremiosRequest
  );
  yield takeLatest(
    ReportsTypes.EXPORT_WEBPREMIOS_REQUEST,
    exportReportWebpremiosRequest
  );
  yield takeLatest(
    ReportsTypes.EXPORT_ACCOUNTANT_REQUEST,
    exportReportAccountantRequest
  );
}
